var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['category-list__item',{'category-list__item--selected': this.active}],on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(this.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }